import React from 'react';
import SvgIcon from '../SvgIcon';
var MinusIcon = function MinusIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M7 15H25V17H7z"
  }));
};
export default MinusIcon;